export default "__VITE_ASSET__1142e78e__"